<template>
  <div>
    <section
      :class="
        'cart-sidebar-modal cart-wrapper body-text-dark' +
        (active ? ' active' : '')
      "
    >
      <div
        :class="
          'cart-sidebar-modal-content' +
          (vg_cartItems.length < 1 ? ' empty-cart' : '')
        "
      >
        <h2 class="order-summary-heading is-size-4 has-text-centered">
          <a href="#" @click.prevent="closeCartModal()" class="close"
            ><img src="@/assets/img/close_24px.png"
          /></a>
          <span class="has-text-weight-semibold">Order Summary</span>
        </h2>

        <!-- If cart is empty -->
        <div
          class="section has-text-grey has-text-centered mt100 mb100 mt0-mobile mb0-mobile"
          v-if="vg_cartItems.length < 1"
        >
          <img src="@/assets/img/icon-basket.svg" alt="image" />
          <p class="is-size-16 mt50">Your cart is empty</p>
          <button
            @click.prevent="continueShopping()"
            class="button mb15 mt-5 is-secondary-outline is-medium is-full-width"
          >
            CONTINUE SHOPPING
          </button>
        </div>
        <!-- Cart is empty ends -->

        <div class="columns is-multiline" v-else>
          <!-- Cart items -->
          <div
            class="column is-12-widescreen is-12-desktop is-12-tablet is-12-mobile"
          >
            <template v-if="cartLoaded">
              <cart-item
                v-for="(product, index) in vg_cartItems"
                :item="product"
                v-bind:key="'cart-item-' + index"
              ></cart-item>
            </template>
          </div>
          <!-- Cart items ends -->

          <div
            class="column is-12-widescreen is-12-desktop is-12-tablet is-12-mobile"
          >
            <div class="order-summary-block">
              <!-- Loyality points starts -->
              <div class="content-box mb15 mt10" v-if="enabledLoyality">
                <!-- if loyalty enabled but user email is not verified -->

                <div class="cart-sidebar-promocode loyality-point-wrapper">
                  <h3
                    class="is-size-16 has-text-weight-bold mb15 has-text-dark"
                  >
                    {{
                      vg_businessLoyality.name ? vg_businessLoyality.name : ""
                    }}
                    <span
                      class="is-size-12 has-text-dark has-text-weight-bold loyality-points-display opacity-6"
                      v-if="vg_cartLoyalityPointsObj.points_redeemable"
                    >
                      <span class="text-primary">
                        <span class="text-primary">
                          {{
                            new Intl.NumberFormat().format(userDisplayCartPoint)
                          }}
                          points
                        </span>
                      </span>
                      <!-- (${{ vg_cartLoyalityPointsObj.points_redeemable_value ? vg_cartLoyalityPointsObj.points_redeemable_value.toFixed(2) : '' }}) -->
                    </span>
                  </h3>

                  <template
                    v-if="
                      vg_loggedInUser &&
                      vg_loggedInUser.email_verification_status
                    "
                  >
                    <div
                      class="cart-sidebar-promocode-content"
                      v-if="vg_cartLoyalityPointsObj.points_redeemable"
                    >
                      <input
                        class="promocode-input has-text-dark hide-default-numb-style"
                        type="number"
                        v-model="loyality_point"
                        value=""
                        placeholder="Input Points"
                      />
                      <button
                        @click.prevent="applyLoyalityPoint()"
                        :class="
                          'cart-modal-apply-promocode has-text-weight-semibold' +
                          (loyality_point > 0
                            ? ''
                            : ' field-disabled opacity-03')
                        "
                      >
                        APPLY
                      </button>
                    </div>
                    <p
                      class="is-size-12 mt-5 has-text-weight-semibold has-text-dark"
                      v-else
                    >
                      Your cart doesn’t have any items you can use points for.
                    </p>
                  </template>
                  <template v-else>
                    <p class="is-size-14 has-text-dark">
                      Your account needs to be verified to redeem points.
                    </p>
                  </template>
                </div>
              </div>
              <!-- Loyality points  ends -->

              <!-- Promocode starts -->
              <div class="content-box">
                <div class="cart-sidebar-promocode">
                  <h3 class="is-size-16 has-text-weight-bold mb15">
                    Promo Code
                  </h3>
                  <div class="cart-sidebar-promocode-content">
                    <input
                      class="promocode-input has-text-dark"
                      v-model="promocode"
                      value=""
                      placeholder="Input Promo Code"
                    />
                    <button
                      @click.prevent="applyPromoCode()"
                      :class="
                        'cart-modal-apply-promocode has-text-weight-semibold' +
                        (promocode ? '' : ' field-disabled opacity-03')
                      "
                    >
                      APPLY
                    </button>
                  </div>
                </div>
              </div>
              <!-- Promocode ends -->

              <!-- Preview order -->
              <div class="cart-review-order">
                <div class="content-box">
                  <div class="level is-mobile mb5">
                    <div class="level-left">
                      <div class="level-item">
                        <p class="sf-pro-text-regular is-size-14 has-text-dark">
                          Limit
                        </p>
                      </div>
                    </div>
                    <div class="level-right">
                      <div class="level-item">
                        <p class="sf-pro-text-regular has-text-dark is-size-14">
                          {{ vg_weightOnCart }}/{{ vg_cannabisLimit }}g
                        </p>
                      </div>
                    </div>
                  </div>

                  <div class="level is-mobile mb5" v-if="!vg_is_greenline_pos">
                    <div class="level-left">
                      <div class="level-item">
                        <p class="sf-pro-text-regular is-size-14 has-text-dark">
                          Subtotal
                        </p>
                      </div>
                    </div>
                    <div class="level-right">
                      <div class="level-item">
                        <p class="sf-pro-text-regular has-text-dark is-size-14">
                          <!-- <span class="subtotal-without-sale-price has-text-dark" v-if="activeSalePriceData.hasActiveSale">
                          <s class="opacity-03">${{ activeSalePriceData.regularPrice}}</s>
                        </span> -->
                          <span
                            :class="
                              'has-text-dark' +
                              (vg_cartPromoCode || vg_cartLoyality
                                ? ' strike'
                                : '')
                            "
                            >${{ vg_cartSubTotal }}</span
                          >
                        </p>
                      </div>
                    </div>
                  </div>

                  <div class="level is-mobile mb5" v-if="vg_is_greenline_pos">
                    <div class="level-left">
                      <div class="level-item">
                        <p class="sf-pro-text-regular is-size-14 has-text-dark">
                          Deposit
                        </p>
                      </div>
                    </div>
                    <div class="level-right">
                      <div class="level-item">
                        <p class="sf-pro-text-regular has-text-dark is-size-14">
                          <span class="has-text-dark"
                            >${{ vg_greenlineProductDeposit }}</span
                          >
                        </p>
                      </div>
                    </div>
                  </div>

                  <div class="level is-mobile mb5" v-if="vg_cartPromoCode">
                    <div class="level-left">
                      <div class="level-item">
                        <p class="sf-pro-text-regular is-size-14 has-text-dark">
                          <span
                            class="removed-promocode"
                            @click.prevent="removePromoCode()"
                            ><i
                              class="fa fa-times-circle"
                              aria-hidden="true"
                            ></i
                          ></span>
                          Promo Code: {{ vg_cartPromoCode.code }}
                        </p>
                      </div>
                    </div>
                    <div class="level-right">
                      <div class="level-item">
                        <p class="sf-pro-text-regular text-green is-size-14">
                          - ${{ vg_cartPromoCode.applied_value.toFixed(2) }}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div class="level is-mobile mb5" v-if="vg_cartLoyality">
                    <div class="level-left">
                      <div class="level-item">
                        <p class="sf-pro-text-regular is-size-14 has-text-dark">
                          <span
                            class="removed-promocode"
                            @click.prevent="removeLoyality()"
                            ><i
                              class="fa fa-times-circle"
                              aria-hidden="true"
                            ></i
                          ></span>
                          Points Used:
                          {{
                            new Intl.NumberFormat().format(
                              vg_cartLoyality.points_to_redeem
                            )
                          }}
                        </p>
                      </div>
                    </div>
                    <div class="level-right">
                      <div class="level-item">
                        <p class="sf-pro-text-regular text-green is-size-14">
                          - ${{ vg_cartLoyality.redeem_amount.toFixed(2) }}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div
                    class="level is-mobile mb5"
                    v-if="
                      (vg_cartPromoCode || vg_cartLoyality) &&
                      !vg_is_greenline_pos
                    "
                  >
                    <div class="level-left">
                      <div class="level-item">
                        <p class="has-text-dark sf-pro-text-regular is-size-14">
                          New Subtotal
                        </p>
                      </div>
                    </div>
                    <div class="level-right">
                      <div class="level-item">
                        <p class="sf-pro-text-regular text-green is-size-14">
                          ${{ vg_newSubTotal }}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div class="level is-mobile mb5">
                    <div class="level-left">
                      <div class="level-item">
                        <p
                          class="has-text-dark sf-pro-text-regular is-size-14 has-text-dark"
                        >
                          Tax
                        </p>
                      </div>
                    </div>
                    <div class="level-right">
                      <div class="level-item">
                        <p
                          class="has-text-dark sf-pro-text-regular is-size-14 has-text-dark"
                        >
                          ${{ vg_cartTax ? vg_cartTax : 0.0 }}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div
                    class="level is-mobile mb0"
                    v-if="
                      vg_checkoutOrderType.order_receive_method == 'delivery'
                    "
                  >
                    <div class="level-left">
                      <div class="level-item">
                        <p class="sf-pro-text-regular is-size-14">
                          Delivery Fee
                        </p>
                      </div>
                    </div>
                    <div class="level-right">
                      <div class="level-item">
                        <p class="sf-pro-text-regular is-size-14">
                          ${{
                            parseFloat(
                              vg_checkoutOrderType.delivery_fee
                            ).toFixed(2)
                          }}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="level is-mobile">
                    <div class="level-left">
                      <div class="level-item">
                        <p
                          class="is-size-16 has-text-weight-bold has-text-dark"
                        >
                          Total
                        </p>
                      </div>
                    </div>
                    <div class="level-right">
                      <div class="level-item">
                        <p
                          class="is-size-16 has-text-weight-bold has-text-dark"
                        >
                          ${{ cartGrandTotal.toFixed(2) }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Review order ends -->
            </div>
          </div>
        </div>
      </div>

      <!-- Cart action -->
      <div class="sidebar-cart-checkout-actions" v-if="vg_cartItems.length > 0">
        <button
          @click.prevent="continueShopping()"
          class="button mb15 mt-5 is-primary-outline is-medium is-full-width"
        >
          CONTINUE SHOPPING
        </button>
        <a
          @click.prevent="moveToCheckout()"
          href="#"
          class="button is-full-width mb15 justify-content-center bg-secondary text-white btn-complete is-medium hover-opacity-8"
        >
          CHECKOUT
        </a>
      </div>
      <!-- Cart action ends -->
    </section>
    <remove-item-modal></remove-item-modal>
    <user-not-logged-in-modal></user-not-logged-in-modal>
    <cart-clear></cart-clear>
    <no-longer-stock></no-longer-stock>
  </div>
</template>

<script>
import ConfirmOrderModal from "@/Components/Pages/PageComponents/Cart/ConfirmOrderModal";
import CartItem from "@/Components/Pages/PageComponents/Cart/CartSidebarItem";

import RemoveItemModal from "@/Components/Pages/PageComponents/Cart/RemoveItemModal";
import UserNotLoggedInModal from "@/Components/Pages/PageComponents/Cart/UserNotLoggedInModal";

import CartClear from "@/Components/Pages/PageComponents/Cart/ClearCart";
import NoLongerStock from "@/Components/Pages/PageComponents/Cart/NoLongerStock";
// lets make a individual component instead, to less methods on this file

import CartApis from "@/Components/Controllers/CartApis";
import LocationApis from "@/Components/Controllers/LocationApis";

import { mapGetters, mapActions, mapMutations } from "vuex";
import Helpers from "@/Components/Helpers/Helpers";
import { find, indexOf } from "lodash";
import moment from "moment";

export default {
  components: {
    ConfirmOrderModal,
    CartItem,
    RemoveItemModal,
    UserNotLoggedInModal,
    CartClear,
    NoLongerStock,
  },

  name: "CartSidebar",
  data() {
    return {
      active: false,
      cartLoaded: true,
      loadedTimeSlots: false,
      confirmOrderModalStatus: false,
      delivery_cutoff: false,
      loaded: false,
      promocode: "",
      loyality_point: "",
    };
  },
  computed: {
    ...mapGetters({
      vg_cartId: "cart/id",
      vg_businessProfile: "businessprofile/detail",
      vg_cartItems: "cart/cartItems",
      vg_selectedStore: "location/selected",
      vg_is_greenline_pos: "location/is_greenline_pos",
      vg_cartSubTotal: "cart/cartSubTotal",
      vg_cartTax: "cart/cartTax",
      vg_newSubTotal: "cart/newSubTotal",
      vg_greenlineProductDeposit: "cart/greenline_product_deposit",
      vg_cartPromoCode: "cart/promocode",
      vg_cartLoyality: "cart/loyality",
      vg_cartGrandTotal: "cart/cartGrandTotal",
      vg_weightOnCart: "cart/cartWeight",
      vg_cannabisLimit: "location/cannabis_limit",
      vg_guestLandedQueries: "location/guestLandedQueries",
      vg_cartLoyalityPointsObj: "cart/loyalityPointsObj",
      vg_userLoyalitySubscription: "userloyalitysubscription/subscribed",
      vg_userLoyalitySubscriptionObj: "userloyalitysubscription/obj",
      vg_userId: "getLoggedInUserId",
      vg_loggedInUser: "getLoggedInUser",
      vg_hasBusinessLoyalityProgram:
        "businessprofile/hasBusinessLoyalityProgram",
      vg_businessLoyality: "businessprofile/businessLoyality",
      vg_checkoutOrderType: "checkout/ordertype",
    }),

    /**
     * Guest user / guest_only active
     */
    kioskMode() {
      return this.$route.query["kiosk"] &&
        (this.$route.query["kiosk"] == 1 ||
          this.$route.query["kiosk"] == "true")
        ? true
        : false;
    },

    enablePickup() {
      // if guest only then pickup always enabled
      if (this.kioskMode == true) {
        return true;
      }
      return this.vg_selectedStore.settings.pickup_orders
        ? this.vg_selectedStore.settings.pickup_orders.is_enabled &&
            this.vg_selectedStore.settings.pickup_orders.is_active
        : false;
    },

    enabledLoyality() {
      // user must be logged in  // user must have subscribed to the programme // business must have enable program
      if (
        this.vg_userId &&
        this.vg_userLoyalitySubscription &&
        this.vg_hasBusinessLoyalityProgram
      ) {
        //this.step = "ordertype";
        return true;
      }
      return false;
    },

    userDisplayCartPoint() {
      if (this.enabledLoyality) {
        // if user account loyalty point is less display that else cart redeem point
        let loyaltyPoints =
          this.vg_cartLoyalityPointsObj.points_redeemable >
          this.vg_userLoyalitySubscriptionObj.points
            ? this.vg_userLoyalitySubscriptionObj.points
            : this.vg_cartLoyalityPointsObj.points_redeemable;
        // if cart has some loyalty
        // if (this.vg_cartLoyality) {
        //   return (
        //     parseInt(loyaltyPoints) -
        //     parseInt(this.vg_cartLoyality.points_to_redeem)
        //   );
        // }
        return loyaltyPoints;
      }

      return 0;
    },

    activeSalePriceData() {
      let hasActiveSale = false;
      let regularPrice = 0;

      this.vg_cartItems.map((item) => {
        if (
          parseFloat(item.selected_variant.sale_price) > 0 &&
          parseFloat(item.selected_variant.sale_price) <
            parseFloat(item.selected_variant.price)
        ) {
          hasActiveSale = true;
        }
        regularPrice += item.unit * item.selected_variant.price;
      });
      return {
        hasActiveSale,
        regularPrice: regularPrice.toFixed(2),
      };
    },

    cartGrandTotal() {
      if (this.vg_is_greenline_pos) {
        return parseFloat(this.vg_cartGrandTotal);
      } else {
        if (this.vg_checkoutOrderType.order_receive_method == "delivery") {
          return (
            parseFloat(this.vg_cartGrandTotal) +
            parseFloat(this.vg_checkoutOrderType.delivery_fee)
          );
        } else {
          return parseFloat(this.vg_cartGrandTotal);
        }
      }
    },
  },

  watch: {
    vg_cartItems: {
      deep: true,
      handler() {
        this.onCartItemChange();
      },
    },

    "delivery.phone"(val, oldVal) {
      if (val && val.length > 10) {
        this.delivery.phone = oldVal;
      }
    },
  },

  async mounted() {
    // We do not need sidebar fetch on this page
    let ignoreUserLoyaltyFetch = [
      "LoginWithUserAuthToken",
      "UserAccountMembership",
    ];
    if (!ignoreUserLoyaltyFetch.includes(this.$route.name)) {
      if (
        this.vg_userId &&
        this.vg_businessLoyality.id &&
        this.vg_businessLoyality.is_active
      ) {
        await this.va_setUserLoyalityObj({
          user_id: this.vg_userId,
          business_id: this.vg_businessProfile.id,
        });
      }
    }

    const self = this;
    // Handle on open close modal background body scroll
    bus.$on("open-sidebar-cart", async (payload) => {
      self.active = payload;
      if (payload) {
        // Send user activy emit, user , location details verified within the function
        Helpers.emitUserActivity();

        document.body.classList.add("cart-modal-active");
        //self.va_setCartLoyalityPointsObj()
        //CartApis.locationCart(this.vg_selectedStore.id, Helpers.getLocationCartFullUrl(this));
        if (
          self.vg_userId &&
          self.vg_businessLoyality.id &&
          self.vg_businessLoyality.is_active
        ) {
          await self.va_setUserLoyalityObj({
            user_id: self.vg_userId,
            business_id: self.vg_businessProfile.id,
          });
        }

        if (this.vg_is_greenline_pos) {
          this.fetchGreenLinePosData();
        }
      } else {
        document.body.classList.remove("cart-modal-active");
      }
    });

    this.loaded = false;
    if (!this.vg_selectedStore.slug) {
      // console.log('Sidebar cart doesnot have location detail.')
      return;
    }
    // We do not need sidebar fetch on this page
    let ignoreRoutes = ["LoginWithUserAuthToken", "VisitorAgeVerification"];
    if (ignoreRoutes.indexOf(this.$route.name) < 0) {
      //console.log('sidebar cart')
      await CartApis.locationCart(
        this.vg_selectedStore.id,
        Helpers.getLocationCartFullUrl(this)
      );
    }
    this.loaded = true;

    // auto selecting pickup/delivery
    document.addEventListener("wheel", function (event) {
      if (document.activeElement.type === "number") {
        document.activeElement.blur();
      }
    });

    bus.$on("listen-mobile-moveto-checkout", () => {
      // listen from mobile screen
      this.moveToCheckout();
    });
  },

  beforeDestroy() {
    bus.$off("listen-mobile-moveto-checkout");
    bus.$off("open-sidebar-cart");
  },

  methods: {
    /**
     * Act on on change cart item
     */
    onCartItemChange: _.debounce(function () {
      // Prevent multiple hits
      if (this.vg_is_greenline_pos) {
        // If any change on cart item fetch pos if greenline pos
        this.fetchGreenLinePosData();
      }
      // When cart is update remount the cart item component to assign uit to custom qty
      this.cartLoaded = false;
      this.$nextTick(() => {
        this.cartLoaded = true;
        // if cart item change get loyality points
        // if(!this.vg_userId){
        // Fetch only if user is not logged in because if logged in we are watching on pubnub
        if (this.vg_cartItems.length > 0) {
          this.va_setCartLoyalityPointsObj({
            order_receive_method: this.vg_checkoutOrderType.order_receive_method
              ? this.vg_checkoutOrderType.order_receive_method
              : "pickup",
          });
        } else {
          this.vm_cartLoyaltyPointMutate({});
        }
        //}
      });
    }, 1000),

    /**
     * Move backwards
     */
    closeCartModal() {
      this.active = false;
      document.body.classList.remove("cart-modal-active");
    },

    /**
     * Move to checkout
     */
    async moveToCheckout() {
      // Push to new page instead on modal
      this.closeCartModal();
      if (this.$route.name == "Checkout") {
        return; //this.closeCartModal();
      }

      let queryToremove = [
        "user_token",
        "category",
        "verify_email",
        "token",
        "search",
        "order_id",
        "signup",
        "signup_token",
      ];
      if (this.vg_userId) {
        queryToremove.push("referral_key");
      }
      this.$router.push({
        name: "Checkout",
        params: {
          store_slug: this.$route.params.store_slug
            ? this.$route.params.store_slug
            : this.vg_selectedStore.slug,
        },
        query: Helpers.refineQuery(queryToremove, this.$route.query),
      });
      this.closeCartModal();
    },

    /**
     * Clear cart modal
     */
    clearCartModal() {
      if (this.vg_cartId) {
        bus.$emit("show-modal-clear-cart", true);
      } else {
        this.va_snackbar({
          type: "warning",
          message: "Cannot find cart.",
        });
      }
    },

    getTodaysOpenCloseSchedule() {
      let todaysSchedule = _.find(
        this.vg_selectedStore.hours_of_operation,
        function (o) {
          return o.day == new Date().getDay();
        }
      );
      if (todaysSchedule != undefined) {
        return this.getOpenCloseTime(todaysSchedule);
      }
      return "";
    },

    // Get opening and closing time for all the days of week
    getOpenCloseTime(item) {
      return `${moment(item.open_time, "HH:mm:ss").format(
        "hh:mm a"
      )} - ${moment(item.close_time, "HH:mm:ss").format("hh:mm a")}`;
    },

    todayDayNumber() {
      return new Date().getDay();
    },

    hasSalePrice(item) {
      if (
        parseFloat(item.selected_variant.sale_price) > 0 &&
        parseFloat(item.selected_variant.sale_price) <
          parseFloat(item.selected_variant.price)
      ) {
        return true;
      }
      return false;
    },

    /**
     * Attach promocode on cart
     */
    async applyPromoCode() {
      if (this.promocode == "") {
        return this.va_snackbar({
          type: "warning",
          message: `Please enter promocode.`,
        });
      }
      this.va_spinner(true);
      let res = await CartApis.promoCodeApply({
        cart_id: this.vg_cartId,
        promocode: this.promocode,
        business_id: this.vg_businessProfile.id,
        user_type:
          this.vg_userId && this.vg_loggedInUser.status == "registered"
            ? "registered"
            : "guest",
      });
      // on success fetch cart
      if (res.status == 200) {
        await CartApis.locationCart(
          this.vg_selectedStore.id,
          Helpers.getLocationCartFullUrl(this)
        );
      } else {
        // for invalid promocode , remove value
        this.promocode = "";
      }
      this.va_spinner(false);
      this.va_snackbar({
        type: res.status == 200 ? "success" : "warning",
        message: res.status == 200 ? res.data.msg : res.response.data.msg,
      });
    },

    /**
     * Apply loyality
     */
    async applyLoyalityPoint() {
      if (parseInt(this.loyality_point) < 1) {
        return this.va_snackbar({
          type: "warning",
          message: `Loyality point must be greater than 0.`,
        });
      }

      this.va_spinner(true);

      let res = await CartApis.redeemPointOnCart({
        cart_id: this.vg_cartId,
        points_to_redeem: parseInt(this.loyality_point),
        order_received_method: this.$store.getters["getInStore"]
          ? "instore"
          : "pickup", // only 2 because we dont have delivery at this stage
      });

      if (res.status == 200) {
        //this.va_setCartLoyalityPointsObj()
        this.loyality_point = "";
        this.$store.dispatch("cart/setCartDetail", res.data.payload);
        this.$store.dispatch("cart/setCartItems", res.data.payload.cart_items);
      }
      this.va_spinner(false);
      return this.va_snackbar({
        type: res.status == 200 ? "success" : "warning",
        message: res.status == 200 ? res.data.msg : res.response.data.msg,
      });
    },

    /**
     * Remove loyality point
     */
    async removeLoyality() {
      this.va_spinner(true);
      let res = await CartApis.removeRedeemPointOnCart(this.vg_cartLoyality.id);
      if (res.status == 200) {
        this.$store.dispatch("cart/setCartDetail", res.data.payload);
        this.$store.dispatch("cart/setCartItems", res.data.payload.cart_items);
      }
      this.va_spinner(false);
    },

    /**
     * On click contunue shopping
     */
    continueShopping() {
      // If this page is either StoreLanding, StoreProfile then close it else move to StoreLanding
      if (
        this.$route.name == "StoreLanding" ||
        this.$route.name == "StoreProfile"
      ) {
        this.closeCartModal();
      } else {
        this.closeCartModal();
        let queryToremove = [
          "user_token",
          "category",
          "verify_email",
          "token",
          "search",
          "order_id",
          "signup",
        ];
        if (this.vg_userId) {
          queryToremove.push("referral_key");
        }
        this.$router.push({
          name: "StoreLanding",
          params: {
            business_slug: this.$route.params.business_slug,
            store_slug: this.vg_selectedStore.slug,
          },
          query: Helpers.refineQuery(queryToremove, this.$route.query),
        });
      }
    },

    /**
     * Remove promocode
     */
    async removePromoCode() {
      if (this.vg_cartPromoCode.code == "") {
        return this.va_snackbar({
          type: "warning",
          message: `Sorry promocode not found.`,
        });
      }
      this.va_spinner(true);
      let res = await CartApis.promoCodeRemove(this.vg_cartPromoCode.id);
      // on success fetch cart
      if (res.status == 200) {
        this.promocode = "";
        await CartApis.locationCart(
          this.vg_selectedStore.id,
          Helpers.getLocationCartFullUrl(this)
        );
      }
      this.va_snackbar({
        type: res.status == 200 ? "success" : "warning",
        message: res.status == 200 ? res.data.msg : res.response.data.msg,
      });
      // refetch cart
      this.va_spinner(false);
    },

    /**
     * Fetch green pos
     */
    async fetchGreenLinePosData() {
      // if(this.$route.name == 'Checkout'){
      //   posdat.order_receive_method = this.vg_checkoutOrderType.order_receive_method;
      //   if(this.vg_userId){
      //     posdat.user = {
      //       first_name: this.vg_loggedInUser.first_name,
      //       last_name: this.vg_loggedInUser.last_name
      //     }
      //   } else {
      //     posdat.user = {
      //       first_name: this.vg_checkoutOrderType.user.first_name ? this.vg_checkoutOrderType.user.first_name : '',
      //       last_name: this.vg_checkoutOrderType.user.last_name ? this.vg_checkoutOrderType.user.last_name : ''
      //     }
      //   }
      //   if(this.vg_checkoutOrderType.order_receive_method == 'delivery'){
      //     posdat.delivery_fee = this.vg_checkoutOrderType.delivery_fee ? this.vg_checkoutOrderType.delivery_fee : 0.00;
      //     posdat.delivery = this.vg_checkoutOrderType.delivery ? this.vg_checkoutOrderType.delivery : {};
      //     if(this.vg_checkoutOrderType.delivery && (this.vg_checkoutOrderType.delivery.address2 == '') ){
      //       posdat.delivery.address2 = 'n/a';
      //     }
      //   }

      // } else {

      //}

      let posdat = {};
      posdat.order_receive_method = "pickup"; // at this stage because its sidebar cart on selected yet
      if (this.vg_userId) {
        posdat.user = {
          first_name: this.vg_loggedInUser.first_name,
          last_name: this.vg_loggedInUser.last_name,
        };
      }
      this.va_setGreenLinePosData(posdat);
    },

    ...mapMutations({
      vm_cartLoyaltyPointMutate: "cart/loyalityPointsObjMutate",
    }),

    ...mapActions({
      va_spinner: "spinner/setSpinner",
      va_snackbar: "snackbar/setSnackbar",
      va_setSelectedLocation: "location/setSelected",
      va_setCartLoyalityPointsObj: "cart/setLoyalityPointsObj",
      va_setUserLoyalityObj: "userloyalitysubscription/setUserLoyalityObj",
      va_setGreenLinePosData: "cart/setGreenLinePosData",
    }),
  },
};
</script>
<style scoped>
.text-sm {
  font-size: 13px;
}
.nab-bar-left {
  display: flex;
  flex-direction: row;
}
.nav-bar-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  /* width: 100%; */
  display: -ms-flexbox;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  width: 100%;
}
.nav-bar-right {
  padding-right: 30px;
}
h1.title {
  margin-top: 9px;
}
.width-300 {
  max-width: 300px;
}
.width-100 {
  width: 100px;
}
.cart-wrapper .order-summary-block .content-box {
  padding: 5px 15px;
}
img.clock {
  left: 15px !important;
}
.ml-10 {
  margin-left: 10px;
}
</style>
